<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6">
          <v-card-title class="text-center text-h4 mb-4">
            Восстановление пароля
          </v-card-title>

          <v-alert
            v-if="showAlert"
            :type="messageType === 'danger' ? 'error' : 'success'"
            variant="tonal"
            closable
            class="mb-4"
            @click:close="showAlert = false"
          >
            {{ message }}
          </v-alert>

          <!-- Show form only if email not sent yet -->
          <v-form v-if="!emailSent" @submit.prevent="handleSubmit">
            <v-text-field
              v-model="email"
              label="Почта"
              type="email"
              variant="outlined"
              required
              :rules="emailRules"
              class="mb-4"
              :disabled="isSubmitting"
            ></v-text-field>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              class="mb-4"
              :loading="isSubmitting"
            >
              Отправить ссылку
            </v-btn>

            <v-row justify="center" class="mt-4">
              <v-col cols="auto">
                <router-link to="/signin" class="text-primary text-decoration-none">
                  Вход
                </router-link>
              </v-col>
              <v-col cols="auto">
                <router-link to="/signup" class="text-primary text-decoration-none">
                  Регистрация
                </router-link>
              </v-col>
            </v-row>
          </v-form>

          <!-- Show success message with resend option -->
          <div v-else class="text-center">
            <v-icon color="success" size="64" class="mb-4">
              mdi-email-check
            </v-icon>
            
            <v-card-text class="text-body-1 mb-4">
              Инструкции по восстановлению пароля отправлены на {{ email }}. 
              Проверьте вашу почту и перейдите по ссылке.
            </v-card-text>
            
            <v-alert 
              type="info" 
              variant="tonal" 
              class="mb-4 text-start"
            >
              <strong>Важно:</strong> Если письмо не пришло, проверьте папку "Спам"
            </v-alert>
            
            <v-divider class="mb-4"></v-divider>
            
            <v-card-text v-if="!canResend" class="text-body-2 text-grey">
              Письмо не дошло? Запросить еще раз через {{ formatTime(countdown) }}
            </v-card-text>
            
            <v-btn
              v-if="canResend"
              color="secondary"
              variant="text"
              @click="resendEmail"
              :loading="isResending"
              class="mb-4"
            >
              Отправить письмо повторно
            </v-btn>
            
            <v-btn
              color="primary"
              size="large"
              variant="elevated"
              :to="'/signin'"
              block
            >
              Перейти к входу
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient from '@/apiClient'

export default {
  data() {
    return {
      email: '',
      message: '',
      messageType: '',
      showAlert: false,
      emailSent: false,
      isSubmitting: false,
      countdown: 60,
      canResend: false,
      isResending: false,
      intervalId: null,
      emailRules: [
        v => !!v || 'Почта обязательна',
        v => /.+@.+\..+/.test(v) || 'Почта должна быть валидной',
      ],
    };
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    handleSubmit() {
      this.isSubmitting = true;
      this.showAlert = false;
      
      apiClient.post('/forgot-password', { email: this.email })
        .then(response => {
          this.showMessage(response.data.message || 'Инструкции отправлены на вашу почту');
          this.emailSent = true;
          this.startCountdown();
        })
        .catch(() => {
          this.showMessage('Ошибка при сбросе пароля, попробуйте позже!', true);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    resendEmail() {
      this.isResending = true;
      this.showAlert = false;
      
      apiClient.post('/forgot-password', { email: this.email })
        .then(() => {
          this.showMessage('Письмо успешно отправлено повторно!');
          // Reset countdown
          this.countdown = 60;
          this.canResend = false;
          this.startCountdown();
        })
        .catch(() => {
          this.showMessage('Ошибка при повторной отправке. Попробуйте позже.', true);
        })
        .finally(() => {
          this.isResending = false;
        });
    },
    startCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.canResend = true;
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
    showMessage(message, isError) {
      if (isError) {
        this.messageType = "danger";
      } else {
        this.messageType = "success";
      }
      this.message = message;
      this.showAlert = true;
    }
  },
  mounted() {
    // Vuetify validation is handled automatically
  }
};
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>
